import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AvailabilityOutput, CalendarEventForDispatchFragment, FullAssetFragment, ViewDatesQuery } from '../../../generated/graphql.generated';

import { ActionSource } from '../../state/action-sources';

import { ScheduleView } from './booking-schedule.state';

export const BookingScheduleActions = createActionGroup({
	source: ActionSource.BOOKING_SCHEDULE,
	events: {
    'Dates Set': props<{
      title: string;
      start: string;
      end: string;
      view: ScheduleView;
    }>(),
    'Month Date Clicked': props<{ date: string }>(),
    'Previous Button Clicked': emptyProps(),
    'Today Button Clicked': emptyProps(),
    'Next Button Clicked': emptyProps(),
    'Calendar View Toggled': emptyProps(),
    'Month Changed': props<{ date: string }>(),
    'Show Events Input Switched': emptyProps(),
    'Load Assets Success': props<{ assets: FullAssetFragment[] }>(),
    'Load Assets Error': props<{ error: Error }>(),
    'Load Events Success': props<{ events: CalendarEventForDispatchFragment[] }>(),
    'Load Events Error': props<{ error: Error }>(),
    'Load Availability Success': props<{ availability: AvailabilityOutput[] }>(),
    'Load Availability Error': props<{ error: Error }>(),
    'Load View Dates Success': props<{ viewDates: ViewDatesQuery['viewDates'] }>(),
    'Load View Dates Error': props<{ error: Error }>(),
    'Toggle Restrictions Button Clicked': emptyProps(),
    'Reload Required': props<{
      start: string;
      end: string;
      assetIds: string[];
    }>(),
    'Enable Scheduling Restrictions Button Clicked': emptyProps(),
    'Override Scheduling Restrictions Button Clicked': emptyProps(),
    'Pay Button Clicked': emptyProps(),
	},
});
